import { Injectable } from '@angular/core';
import { ISSLocalStorageModel } from './i-ss-local-storage.model';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SSLocalStorageService extends LocalStorageService<ISSLocalStorageModel> {


  constructor() {
    super({
      inactiveFrom: {
        parse: (value) => !value ? null : Number(value),
        stringify: (value) => !value ? null : value.toString()
      }
    })

    this._load();
  }

}
